import { useState, useEffect, useCallback } from 'react';
import { url } from '../../../api';
import { apiClient } from '../../../api/client';
import { coffeeChainPaths } from '../../coffee_card_web/api/paths';
import { getAuthToken } from '../../../utils/authTokens';

export interface Chain {
    _id: string;
    name: string;
    slug: string;
    description?: string;
    website?: string;
    country?: string;
    isActive: boolean;
    totalLocations: number;
    totalRatings: number;
    averageRating: number;
}

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getAuthToken()}` } });

export function useChains() {
    const [chains, setChains] = useState<Chain[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchChains = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await apiClient.get(`${url}${coffeeChainPaths.list()}`, authHeaders());
            setChains(res.data?.chains || []);
        } catch (err: any) {
            const raw = err?.response?.data?.error;
            const msg = typeof raw === 'object' && raw?.message ? raw.message : (typeof raw === 'string' ? raw : err?.response?.data?.message || 'Failed to fetch chains');
            setError(msg);
            setChains([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchChains();
    }, [fetchChains]);

    return { chains, loading, error, refetch: fetchChains };
}
